import { Navigate, useLocation } from 'react-router-dom';

/**
 * Sends a renamed page's old address to its new one. Whatever follows the old
 * prefix (a list ID), the query string (Find Leads filters) and the hash are
 * kept, so bookmarks and shared links from before a rename still land.
 */
export function RenamedPath({ from, to }: { from: string; to: string }) {
  const location = useLocation();
  const rest = location.pathname.startsWith(from) ? location.pathname.slice(from.length) : '';
  return <Navigate to={`${to}${rest}${location.search}${location.hash}`} replace />;
}
